import { render, staticRenderFns } from "./LeadBaseDataForm.vue?vue&type=template&id=377938d0&"
import script from "./LeadBaseDataForm.vue?vue&type=script&lang=js&"
export * from "./LeadBaseDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports